 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","Seraa":"Seraa","book":"book","fikria":"fikria","live":"live","muharram":"muharram","news":"news","news_all":"news_all","news_article":"news_article","news_interview":"news_interview","news_literature":"news_literature","news_photo":"news_photo","news_photov2":"news_photov2","news_report":"news_report","news_stories":"news_stories","news_video":"news_video","publications":"publications","DeansAward":"DeansAward","contact":"contact","message_i":"message_i","news_inner":"news_inner","videos":"videos","history":"history","description":"description","structure":"structure","stories_inner":"stories_inner","home":"home"}[chunkId]||chunkId) + "." + {"404":"b7ef38d2","chunk-234162f6":"56c45991","chunk-2cdd48a4":"bd583398","chunk-2da9f6d4":"47b43319","Seraa":"4132ca58","chunk-3dae3ad2":"8006b846","book":"3c6d31b0","fikria":"1fea0419","live":"dcae4c61","muharram":"529f6c0f","news":"d8be73fd","news_all":"40dc2ce1","news_article":"a49a392b","news_interview":"a5eeceb4","news_literature":"d9aa903e","news_photo":"cafc2c29","news_photov2":"13f56209","news_report":"c428dd93","news_stories":"c7366de8","news_video":"cb1635ac","publications":"c1972c28","chunk-840f10ee":"fbc058a2","DeansAward":"9e166493","contact":"821a0cfa","message_i":"716cfce6","news_inner":"57c757ef","videos":"517f7c21","history":"b125219d","description":"8e74a123","structure":"05a05bf2","stories_inner":"0acfdbf8","chunk-27f7b96c":"c21bd2df","home":"b95f7395","chunk-5c5c9654":"64ee3bb8","chunk-79b1724c":"4b2ef4c0","chunk-af4046c4":"e475fe6a","chunk-07360cfb":"bfa8798a","chunk-651d13dc":"8974a3aa","chunk-272f1447":"f68f37d1","chunk-3e21839e":"45317a2e","chunk-4c422265":"6a6b1468","chunk-65dd67f0":"d88cb209","chunk-fe09224a":"bc543e83","chunk-5b81e799":"f9841d37","chunk-ef9c892c":"7f08a14d","chunk-39e3353b":"a32265f7","chunk-3f337211":"65a4bfc1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-234162f6":1,"chunk-2cdd48a4":1,"chunk-2da9f6d4":1,"Seraa":1,"chunk-3dae3ad2":1,"book":1,"fikria":1,"live":1,"muharram":1,"news":1,"news_all":1,"news_article":1,"news_interview":1,"news_literature":1,"news_photo":1,"news_photov2":1,"news_report":1,"news_stories":1,"news_video":1,"publications":1,"chunk-840f10ee":1,"DeansAward":1,"contact":1,"message_i":1,"news_inner":1,"videos":1,"history":1,"description":1,"structure":1,"stories_inner":1,"chunk-27f7b96c":1,"chunk-5c5c9654":1,"chunk-79b1724c":1,"chunk-af4046c4":1,"chunk-07360cfb":1,"chunk-651d13dc":1,"chunk-272f1447":1,"chunk-3e21839e":1,"chunk-4c422265":1,"chunk-65dd67f0":1,"chunk-fe09224a":1,"chunk-5b81e799":1,"chunk-ef9c892c":1,"chunk-39e3353b":1,"chunk-3f337211":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","Seraa":"Seraa","book":"book","fikria":"fikria","live":"live","muharram":"muharram","news":"news","news_all":"news_all","news_article":"news_article","news_interview":"news_interview","news_literature":"news_literature","news_photo":"news_photo","news_photov2":"news_photov2","news_report":"news_report","news_stories":"news_stories","news_video":"news_video","publications":"publications","DeansAward":"DeansAward","contact":"contact","message_i":"message_i","news_inner":"news_inner","videos":"videos","history":"history","description":"description","structure":"structure","stories_inner":"stories_inner","home":"home"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","chunk-234162f6":"3267bb83","chunk-2cdd48a4":"a73aec60","chunk-2da9f6d4":"1a31b591","Seraa":"2295c395","chunk-3dae3ad2":"6be7f72d","book":"a99427fa","fikria":"f65b3347","live":"32c2ebaa","muharram":"28377eee","news":"6760202f","news_all":"e27323a4","news_article":"5a408bd9","news_interview":"5a408bd9","news_literature":"473a3dea","news_photo":"57348f6d","news_photov2":"256cf3f0","news_report":"5a408bd9","news_stories":"9bb61b77","news_video":"5a408bd9","publications":"f4910afd","chunk-840f10ee":"65e4acd1","DeansAward":"5179d640","contact":"904a1c3c","message_i":"02b692eb","news_inner":"7426babc","videos":"90b29f23","history":"478b71d5","description":"589818a3","structure":"607eaeec","stories_inner":"6f82776c","chunk-27f7b96c":"e287307a","home":"31d6cfe0","chunk-5c5c9654":"29abd48e","chunk-79b1724c":"69543ff2","chunk-af4046c4":"dcf7d610","chunk-07360cfb":"3aa8229d","chunk-651d13dc":"fb0e9489","chunk-272f1447":"9196ef73","chunk-3e21839e":"cb720b3d","chunk-4c422265":"be305a38","chunk-65dd67f0":"bf409809","chunk-fe09224a":"ea4497d0","chunk-5b81e799":"5814a5aa","chunk-ef9c892c":"277bfa3d","chunk-39e3353b":"793dedab","chunk-3f337211":"7840c79a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
